import React from "react";
import "../styles/footer.css";
import LogoImage from "../assets/logo.png"; // Adjust the path as needed
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";

const Footer = () => {
  const location = useLocation();

  return (
    <footer className="footer-section">
      <div className="footer-content">
        {/* Left: Logo & tagline */}
        <div className="footer-col footer-brand">
          <div>
            <img src={LogoImage} alt="Serenity Logo" className="footer-logo" />
          </div>
          <div className="footer-tagline">
            From Uncertainty to Financial Serenity
          </div>
          <div className="footer-socials">
            <a
              href="https://www.linkedin.com/company/serenityymarketingmanagement/posts/?feedView=all"
              aria-label="LinkedIn"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-linkedin-in"></i>
            </a>
            <a
              href="https://www.instagram.com/serenityy.management/"
              aria-label="Instagram"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-instagram"></i>
            </a>
            <a
              href="https://wa.me/971543065542"
              aria-label="WhatsApp"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-whatsapp"></i>
            </a>
          </div>
        </div>

        <div className="footer-rev-section">
          {/* Middle: Links */}
          <div className="footer-col footer-links">
            <div>
              <ul>
                <li>
                  <Link
                    to="/"
                    onClick={(e) => {
                      if (location.pathname === "/") {
                        e.preventDefault();
                        window.scrollTo({ top: 0, behavior: "smooth" });
                      }
                    }}
                  >
                    Home
                  </Link>
                </li>
                <li>
                  <Link
                    to="/about"
                    onClick={(e) => {
                      if (location.pathname === "/about") {
                        e.preventDefault();
                        window.scrollTo({ top: 0, behavior: "smooth" });
                      }
                    }}
                  >
                    About Us
                  </Link>
                </li>
                <li>
                  <Link
                    to="/services"
                    onClick={(e) => {
                      if (location.pathname === "/services") {
                        e.preventDefault();
                        window.scrollTo({ top: 0, behavior: "smooth" });
                      }
                    }}
                  >
                    Services
                  </Link>
                </li>
                <li>
                  <Link
                    to="/blogs"
                    onClick={(e) => {
                      if (location.pathname === "/blogs") {
                        e.preventDefault();
                        window.scrollTo({ top: 0, behavior: "smooth" });
                      }
                    }}
                  >
                    Blogs
                  </Link>
                </li>
              </ul>
            </div>
            <div>
              <ul>
                <li>
                  <Link
                    to="/contact"
                    onClick={(e) => {
                      if (location.pathname === "/contact") {
                        e.preventDefault();
                        window.scrollTo({ top: 0, behavior: "smooth" });
                      }
                    }}
                  >
                    Contact Us
                  </Link>
                </li>
                <li>
                  <Link
                    to="/privacy"
                    onClick={(e) => {
                      if (location.pathname === "/privacy") {
                        e.preventDefault();
                        window.scrollTo({ top: 0, behavior: "smooth" });
                      }
                    }}
                  >
                    Privacy Policy
                  </Link>
                </li>
                <li>
                  <Link
                    to="/disclaimer"
                    onClick={(e) => {
                      if (location.pathname === "/disclaimer") {
                        e.preventDefault();
                        window.scrollTo({ top: 0, behavior: "smooth" });
                      }
                    }}
                  >
                    Disclaimer
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          {/* Right: Contact */}
          <div className="footer-col footer-contact">
            <div className="footer-contact-heading">CONTACT</div>
            <div className="footer-contact-row">
              <i className="fas fa-phone"></i>
              <span>+971 43827715</span>
            </div>
            <div className="footer-contact-row">
              <i className="fas fa-envelope"></i>
              <span>info@serenityy.ae</span>
            </div>
            <div className="footer-contact-row">
              <i className="fas fa-map-marker-alt"></i>
              <span>
                19th Floor, Conrad Dubai, Trade Center 1, Sheikh Zayed Road Dubai
                U.A.E, P.O Box- 5610
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <hr />
        <div className="footer-bottom-text">
          <span>
            © 2025 Serenityy, Inc. All rights reserved. <br />
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
